import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { Role } from '@web/shared/module/auth';
import { UserStatus } from '../../enums/user-status';
import { UserContextOperationsResponse } from './user-context-operations.response';
import { AccountType } from '../../enums/account-type';

@jsonObject
export class UserResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly accountType!: AccountType;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly firstName?: Nillable<string>;

  @jsonMember(String)
  public readonly lastName?: Nillable<string>;

  @jsonMember(String)
  public readonly displayName?: Nillable<string>;

  @jsonMember(String)
  public readonly username!: string;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly status!: UserStatus;

  @jsonMember(Date)
  public readonly activatedAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly lastLoginAt?: Nillable<Date>;

  @jsonMember(Date)
  public readonly lastPasswordChangeAt?: Nillable<Date>;

  @jsonMember(Boolean)
  public readonly newsletter!: boolean;

  @jsonArrayMember(String)
  public readonly roles!: Role[];

  @jsonMember(UserContextOperationsResponse)
  public readonly contextOperations!: UserContextOperationsResponse;
}
